// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1pG2Z","colMin":"styles_colMin__1gBdr","colCheckbox":"styles_colCheckbox___rMDT"};